var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"img-fluid",attrs:{"src":require('../../static/GDQ-Associates-White.png')}})
}
var staticRenderFns = []

export { render, staticRenderFns }